export default __webpack_public_path__ + "static/media/video_test.659a665b.mp4";